exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.footer-menu {\n    margin-top: auto;\n}\n@media only screen and (max-width: 768px) {\n.footer-menu {\n      padding-top: 25px;\n}\n}\n", ""]);

// exports
